export default "__VITE_ASSET__DJoxAqwN__"